import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { JanelaAtualizacaoInformacoes } from "src/app/model/janelas-atualizacao-informacoes.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
})
export class JanelasAtualizacaoInformacoesService extends FgiBackEndService<JanelaAtualizacaoInformacoes>{

    getNewEntity(): JanelaAtualizacaoInformacoes {
        const model = new JanelaAtualizacaoInformacoes();
        return model;
    }

    protected getResourceURL(): string {
        return 'front/janela-atualizacao-informacao';
    }

    getJanelasAtualizacaoInformacao(params?: any): any{
        return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<JanelaAtualizacaoInformacoes>>;
    }

    // @Override
    save(janela: JanelaAtualizacaoInformacoes): Observable<JanelaAtualizacaoInformacoes> {

        const options: any = blockUi();
    
        if (janela.id) {
            return this.http.post(`${this.BASE_URL}/${janela.id}`, janela, options).pipe(
                catchError((e) => this.handleError(e))) as Observable<JanelaAtualizacaoInformacoes>;
        }
        else {
            return this.http.post(`${this.BASE_URL}`, janela, options).pipe(
                catchError((e) => this.handleError(e))) as Observable<JanelaAtualizacaoInformacoes>;
        }
      }

      excluir(id: number): Observable<void> {
        const options: any = blockUi();
        
        return this.http.post(`${this.BASE_URL}/${id}/excluir`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<void>;
      }

      habilitarProcessamento(id: number): Observable<JanelaAtualizacaoInformacoes> {
        const options: any = blockUi();
        
        return this.http.post(`${this.BASE_URL}/${id}/habilitar-processamento`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaAtualizacaoInformacoes>;
      }

      desabilitarProcessamento(id: number): Observable<JanelaAtualizacaoInformacoes> {
        const options: any = blockUi();
        
        return this.http.post(`${this.BASE_URL}/${id}/desabilitar-processamento`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaAtualizacaoInformacoes>;
      }
}